import Vue from 'vue';
import { linkBus } from '../link-bus.js';

export default Vue.component('link-item', {
  template: require('./template.html'),
  name: 'link-item',
  props: ['link', 'active-link', 'links', 'index', 'first-level'],
  methods: {
    emitEvent(params) {
      params.payload.firstLevel = this.firstLevel;
      linkBus.$emit(params.type, params.payload);
    },
    toggleSubList(e) {
      const subList = e.currentTarget.parentNode.nextElementSibling;
      if (subList.style.display !== 'none') {
        subList.style.display = 'none';
      } else {
        subList.style.display = 'block';
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/components/editor-links/link-item/index.js